import { enums as QUESTION } from "@/config/enums/Question"
import { useAppStore } from './appStore'
export const useSurveyStore = defineStore("surveyStore", {
  state: () => ({
    survey: {},
    answersStep: {},
    shouldReSelectSpec: 0,
    uploadErrors: {},
    academicIntegrityConfirmed: false,
  }),
  getters: {
    getAnswers: (state) => {
      return state.survey.answers
    },
    formTypeId: (state) => {
      return state.survey.formType.id
    },
    getSurvey: (state) => {
      return state.survey
    },
    getSelectedSpecialityName: (state) => {
      const appStore = useAppStore()
      const specQuestionId = state.survey.program.programLevel.id === 1
          ? QUESTION.WhatSpecMM
          : QUESTION.WhatSpecMB
      const specAnswer = state.survey.answers?.[specQuestionId]
      return !state.survey.answers?.[QUESTION.OtherSpec] && specAnswer
                      ? appStore.getProgramSpeciality(specAnswer).name 
                      : state.survey.answers?.[QUESTION.OtherSpec]
    },
  },
  actions: {
    getAnswer(id) {
      return this.survey.answers?.[id]
    },
    getAnswersInStep(dataAnswers) {
      // console.log(dataAnswers)
      this.answersStep = dataAnswers
    },
    getQuestion(id) {
      const searchDeep = (questions) => {
        for (const question of questions) {
          if (question.id == id) return question
          if (question.children?.length > 0) {
            const found = searchDeep(question.children)
            if (found) return found
          }
          if (question.options?.length > 0) {
            for (const option of question.options) {
              if (option.subQuestions?.length > 0) {
                const found = searchDeep(option.subQuestions)
                if (found) return found
              }
            }
          }
        }
        return null
      }
      for (const step of this.survey.steps ?? []) {
        const found = searchDeep(step.questions ?? [])
        if (found) return found
      }
      return null
    },
    getOption(id) {
      let foundOption = null

      this.survey.steps.some((step) =>
        step.questions.some((question) => {
          if (question.options?.length > 0) {
            const option = question.options.find((option) => option.id == id)
            if (option) {
              foundOption = option.content
              return true
            }
          }
          if (!foundOption && question.children?.length > 0) {
            question.children.some((child) => {
              const option = child.options?.find((option) => option.id == id)
              if (option) {
                foundOption = option.content
                return true
              }
            })
          }

          return foundOption
        })
      )

      return foundOption
    },

    getSubQuestionId(id) {
      let foundOption = {}

      this.survey.steps.some((step) =>
        step.questions.some((question) => {
          if (question.options?.length > 0) {
            const option = question.options.find((option) => option.id == id)

            if (option && option.subQuestions?.length > 0) {
              option.subQuestions.forEach((subQuestion) => {
                foundOption = subQuestion.id
              })
            }
          }

          if (!foundOption.length && question.children?.length > 0) {
            question.children.some((child) => {
              const option = child.options?.find((option) => option.id == id)
              if (option && option.subQuestions?.length > 0) {
                option.subQuestions.forEach((subQuestion) => {
                  foundOption = subQuestion.id
                })
              }
            })
          }
          return foundOption.length > 0
        })
      )

      return foundOption
    },

    setSurvey(survey) {
      this.survey = survey
    },

    resetSurvey() {
      this.survey = []
    },
    setAnswer(id, value) {
      if (!this.survey) {
        this.survey = { answers: {} }
      } else if (!this.survey.answers) {
        this.survey.answers = {}
      }

      this.survey.answers[id] = value
    },
    setUploadError(questionId, msg) {
      this.uploadErrors[questionId] = msg
    },
    clearUploadError(questionId) {
      delete this.uploadErrors[questionId]
    },
    setAcademicIntegrityConfirmed(value) {
      this.academicIntegrityConfirmed = value
    },
    removeAnswer(id) {
      if (!this.survey) {
        this.survey = { answers: {} }
      } else if (!this.survey.answers) {
        this.survey.answers = {}
      }

      delete this.survey.answers[id]
    }
  },
})
